import { useSelector } from 'react-redux';
import { selectCurrentHistoryItem } from 'services/store/remixer/selectors';

/**
 * @deprecated: use selectCurrentHistoryItem selector instead
 */
const useHistoryItem = () => {
  const currentHistoryItem = useSelector(selectCurrentHistoryItem);
  return currentHistoryItem;
};

export default useHistoryItem;
